// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZuCa8TR07o2NYOUX5IBL{display:flex;gap:.5rem}", "",{"version":3,"sources":["webpack://./src/templates/certificates/social_share.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,SAAA","sourcesContent":[".social_share_container {\n  display: flex;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"social_share_container": "ZuCa8TR07o2NYOUX5IBL"
};
export default ___CSS_LOADER_EXPORT___;
